module.exports = __webpack_public_path__ + "media/images/emblems/Chateau-dOex-coat_of_arms-32fa30e1e5167f069ac5c1602741a4d2.svg";